import React from 'react';
import styles from '../styles/comingSoonOverlay.module.css';

interface ComingSoonOverlayProps {
  message?: string;
  isVisible: boolean;
}

const ComingSoonOverlay: React.FC<ComingSoonOverlayProps> = ({ 
  message = "Coming Soon", 
  isVisible 
}) => {
  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.overlayContent}>
        <div className={styles.icon}>🚧</div>
        <h2 className={styles.title}>{message}</h2>
        <p className={styles.description}>
          This feature is currently under development and will be available soon.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonOverlay;
